import { composeConfigs, PreviewWeb, ClientApi } from 'storybook/internal/preview-api';
  import '/virtual:/@storybook/builder-vite/setup-addons.js';
  import { importFn } from '/virtual:/@storybook/builder-vite/storybook-stories.js';
  
    
  const getProjectAnnotations = async (hmrPreviewAnnotationModules = []) => {
    const configs = await Promise.all([hmrPreviewAnnotationModules.at(0) ?? import('@storybook/vue3/dist/entry-preview.mjs'),
hmrPreviewAnnotationModules.at(1) ?? import('@storybook/vue3/dist/entry-preview-docs.mjs'),
hmrPreviewAnnotationModules.at(2) ?? import('@storybook/addon-links/preview'),
hmrPreviewAnnotationModules.at(3) ?? import('@storybook/addon-essentials/docs/preview'),
hmrPreviewAnnotationModules.at(4) ?? import('@storybook/addon-essentials/backgrounds/preview'),
hmrPreviewAnnotationModules.at(5) ?? import('@storybook/addon-essentials/viewport/preview'),
hmrPreviewAnnotationModules.at(6) ?? import('@storybook/addon-essentials/measure/preview'),
hmrPreviewAnnotationModules.at(7) ?? import('@storybook/addon-essentials/outline/preview'),
hmrPreviewAnnotationModules.at(8) ?? import('@storybook/addon-essentials/highlight/preview'),
hmrPreviewAnnotationModules.at(9) ?? import('@storybook/addon-a11y/preview'),
hmrPreviewAnnotationModules.at(10) ?? import('@whitespace/storybook-addon-html/preview'),
hmrPreviewAnnotationModules.at(11) ?? import('@storybook/addon-interactions/preview'),
hmrPreviewAnnotationModules.at(12) ?? import('/.storybook/preview.ts')])
    return composeConfigs(configs);
  }

    window.__STORYBOOK_PREVIEW__ = window.__STORYBOOK_PREVIEW__ || new PreviewWeb(importFn, getProjectAnnotations);
    
    window.__STORYBOOK_STORY_STORE__ = window.__STORYBOOK_STORY_STORE__ || window.__STORYBOOK_PREVIEW__.storyStore;
    
    if (import.meta.hot) {
      import.meta.hot.accept('/virtual:/@storybook/builder-vite/storybook-stories.js', (newModule) => {
      // importFn has changed so we need to patch the new one in
      window.__STORYBOOK_PREVIEW__.onStoriesChanged({ importFn: newModule.importFn });
      });

    import.meta.hot.accept(["@storybook/vue3/dist/entry-preview.mjs","@storybook/vue3/dist/entry-preview-docs.mjs","@storybook/addon-links/preview","@storybook/addon-essentials/docs/preview","@storybook/addon-essentials/backgrounds/preview","@storybook/addon-essentials/viewport/preview","@storybook/addon-essentials/measure/preview","@storybook/addon-essentials/outline/preview","@storybook/addon-essentials/highlight/preview","@storybook/addon-a11y/preview","@whitespace/storybook-addon-html/preview","@storybook/addon-interactions/preview","/.storybook/preview.ts"], (previewAnnotationModules) => {
      
  const getProjectAnnotations = async (hmrPreviewAnnotationModules = []) => {
    const configs = await Promise.all([hmrPreviewAnnotationModules.at(0) ?? import('@storybook/vue3/dist/entry-preview.mjs'),
hmrPreviewAnnotationModules.at(1) ?? import('@storybook/vue3/dist/entry-preview-docs.mjs'),
hmrPreviewAnnotationModules.at(2) ?? import('@storybook/addon-links/preview'),
hmrPreviewAnnotationModules.at(3) ?? import('@storybook/addon-essentials/docs/preview'),
hmrPreviewAnnotationModules.at(4) ?? import('@storybook/addon-essentials/backgrounds/preview'),
hmrPreviewAnnotationModules.at(5) ?? import('@storybook/addon-essentials/viewport/preview'),
hmrPreviewAnnotationModules.at(6) ?? import('@storybook/addon-essentials/measure/preview'),
hmrPreviewAnnotationModules.at(7) ?? import('@storybook/addon-essentials/outline/preview'),
hmrPreviewAnnotationModules.at(8) ?? import('@storybook/addon-essentials/highlight/preview'),
hmrPreviewAnnotationModules.at(9) ?? import('@storybook/addon-a11y/preview'),
hmrPreviewAnnotationModules.at(10) ?? import('@whitespace/storybook-addon-html/preview'),
hmrPreviewAnnotationModules.at(11) ?? import('@storybook/addon-interactions/preview'),
hmrPreviewAnnotationModules.at(12) ?? import('/.storybook/preview.ts')])
    return composeConfigs(configs);
  }
      // getProjectAnnotations has changed so we need to patch the new one in
      window.__STORYBOOK_PREVIEW__.onGetProjectAnnotationsChanged({ getProjectAnnotations: () => getProjectAnnotations(previewAnnotationModules) });
    });
  };